/**
 * #976 — carries the adapters' `onUnavailable` reports to whichever controllers
 * are mounted. One channel is passed to BOTH adapters (as `options`) and to
 * both providers (as `availability`), so a report reaches each controller's
 * `markUnavailable`. With no sink connected a report is dropped.
 *
 * Relative imports only: `integration/` imports this module.
 */
import type { CardAvailabilityOptions, CardTarget, CardUnavailableTarget } from './types';

export interface CardAvailabilityChannel {
  /** Hand to `createCardNoteAdapter` / `createCardSourceAdapter`. */
  options: CardAvailabilityOptions;
  /** A controller subscribes; returns its cleanup. */
  connect(sink: (targets: readonly CardTarget[]) => void): () => void;
}

export function createCardAvailabilityChannel(): CardAvailabilityChannel {
  const sinks = new Set<(targets: readonly CardTarget[]) => void>();
  return {
    options: {
      onUnavailable(reports: readonly CardUnavailableTarget[]) {
        const targets = reports.map((r) => r.target);
        for (const sink of [...sinks]) sink(targets);
      },
    },
    connect(sink) {
      sinks.add(sink);
      return () => { sinks.delete(sink); };
    },
  };
}
